import React, {useEffect, useRef, useState} from 'react'
import {
  ContainerDimensionsContextProvider,
  useIsBreakpointActive,
} from '@therms/atalaya'
import {
  BreadcrumbsSlot,
  useBreadcrumbsContext,
  useCurrentUser,
  useRPCContext,
  useWindowSize,
} from '@therms/react-modules'
import {DesktopLeftMenu} from '../components/LeftMenu/DesktopLeftMenu'
import {MobileNav} from '@src/modules/Layout/components/MobileNav'
import {MobileAppDownloadModal} from '@src/modules/Layout/components/MobileAppDownloadModal'
import {UserAnPRestrictedDutyStatusWrapper} from '@src/modules/Layout/components/UserAnPRestrictedDutyStatusView'

interface AppLayoutContainerProps {
  children: React.ReactElement
}

function AppLayoutContainer({children}: AppLayoutContainerProps) {
  const {breadcrumbs} = useBreadcrumbsContext()
  const {userClientMetadata} = useCurrentUser()
  const [showAppDownloadModal, setShowAppDownloadModal] = useState(
    !userClientMetadata.webClientData?.hasLoggedIntoOPS,
  )
  const {width} = useWindowSize()
  const isLgDisplay = useIsBreakpointActive('md')
  const mainRef = useRef<HTMLDivElement>(null)
  const menuRef = useRef<HTMLDivElement>(null)
  const {rpcService} = useRPCContext()

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!userClientMetadata.webClientData?.hasLoggedIntoOPS) {
        rpcService.Auth.SaveUserClientMetadataWebData.v1.call({
          webClientData: {hasLoggedIntoOPS: true},
        })
      }
    }, 2000)

    return () => clearTimeout(timeout)
  }, [userClientMetadata.webClientData?.hasLoggedIntoOPS])

  return (
    <UserAnPRestrictedDutyStatusWrapper>
      <div className="flex h-full">
        {isLgDisplay && <DesktopLeftMenu ref={menuRef} />}

        <div
          className="relative flex flex-1 flex-col overflow-y-auto"
          style={{
            // we set the width explicitly so children don't cause horizontal scroll
            width:
              width - (menuRef?.current?.getBoundingClientRect().width || 0),
          }}
        >
          {!!breadcrumbs?.length && (
            <div className="z-sticky border-border bg-surface-subtle px-xs py-xxs sticky top-0 border-b">
              <BreadcrumbsSlot />
            </div>
          )}

          <ContainerDimensionsContextProvider containerRef={mainRef} asViewport>
            <main className="flex-1 overflow-y-auto" ref={mainRef}>
              {children}
            </main>
          </ContainerDimensionsContextProvider>

          {!isLgDisplay && <MobileNav />}
        </div>

        {showAppDownloadModal && (
          <MobileAppDownloadModal
            closeHandler={() => setShowAppDownloadModal(false)}
          />
        )}
      </div>
    </UserAnPRestrictedDutyStatusWrapper>
  )
}

export {AppLayoutContainer}
